import React, { useState, useEffect } from "react";
import { Card, Table, Modal, Col, Row, Button } from "react-bootstrap";
import AddIcon from '@material-ui/icons/Add'
import {Dialog,FormControl,FormLabel,Select,MenuItem, FormHelperText, InputLabel} from '@material-ui/core';
import { Button as FormButton } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import PropTypes from 'prop-types'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import { TiTimes } from 'react-icons/ti';
import { BiArrowFromBottom, BiTrash } from 'react-icons/bi';
import { BsTrash2 } from 'react-icons/bs';
import { GrUpdate } from 'react-icons/gr';
import { MdDelete, MdSystemUpdateAlt } from 'react-icons/md';
import { TagsInput } from '../../General';

const defaultOption = {
    goto: 'next',
    label: '',
    value: '',
    order: 0
}

const defaultQuestion = {
	label: '',
	description: '',
	instructions: '',
	localization: 'US-EN',
	help: '',
	status: 'pending',
	type: '',
    dictionnary: '',
    options: [],
	tag: []
};

const defaultGotoOptions = [
    {label: 'Next', value: 'next'},
    {label: 'End', value: 'end'},
]

function Builder(props) {
    const { data, onUpdate, onDelete, showActionButtons, mode, question, setQuestion, originalQuestion } = props;
    const [ newOption, setNewOption ] = useState(defaultOption);
    const [ gotoOptions, setGotoOptions ] = useState(defaultGotoOptions);
    const [ goto, setGoto ] = useState('next');
    const questionTypes = React.useMemo(
		() => [
			{
				label: 'Yes/No',
				type: 'Boolean'
			},
			{
				label: 'Multi Select List',
				type: 'LIST_MULTI'
      },
      {
				label: 'Multi Select Matrix',
				type: 'MATRIX_MULTI'
			},
			{
				label: 'Single Select List',
				type: 'LIST_SINGLE'
			},
			{
				label: 'Text Entry',
				type: 'TEXT'
			},
			{
				label: 'Temperature',
				type: 'TEMP'
			},
			{
				label: 'Mood',
				type: 'MOOD'
			},
			{
				label: 'Pain Scale',
				type: 'PAIN_SCALE'
			},
			{
				label: 'Horizontal Scale',
				type: 'HORIZONTAL_SCALE'
			},
			{
				label: 'Body Map Single Select',
				type: 'SVG_SINGLE'
			},
			{
				label: 'Body Map Multi Select',
				type: 'SVG_MULTI'
			},
			{
				label: 'Date',
				type: 'DATE'
			},
		],
		[]
  );

    useEffect(() => {
        if (data && data.questions) {
            var arr = [...defaultGotoOptions];
            data.questions.forEach((question, index) => {
                arr.push({label: `#${index+1}`, value: index});
            });
            setGotoOptions(arr);
        }
    }, [data])

    useEffect(() => {
        if (originalQuestion && question.options[0]) {
            setGoto(question.options[0].goto);
        }
    }, [originalQuestion, question])

    const handleNewOption = (event) => {
        setNewOption({
          ...newOption,
          [event.target.name]: event.target.value
        })
    }
    const addOption = () => {
        setQuestion({
          ...question,
          options: [...question.options, {...newOption, value: `${question.options.length}`, order: question.options.length + 1}]
        })
        setNewOption(defaultOption);
    }
    const editOption = (newValue, index, field) => {
        var arr = question.options;
        arr[index] = {
            ...arr[index],
            [field]: newValue
        }
        setQuestion({
            ...question,
            options: arr
        })
    }
    const reorder = (target) => {
        const oldIndex = question.options.indexOf(target);
        var arr = [];
        if (oldIndex !== 0) {
            for (var i = 0; i < question.options.length; i++) {
                if (i === oldIndex - 1) {
                    arr.push({
                        ...question.options[oldIndex],
                        order: arr.length + 1
                    })
                }
                else if (i === oldIndex) {
                    arr.push({
                        ...question.options[oldIndex - 1],
                        order: arr.length + 1
                    })
                }
                else {
                    arr.push({
                        ...question.options[i],
                        order: arr.length + 1
                    })
                }
            }
            setQuestion({
                ...question,
                options: arr
            })
        }
    }
    const deleteOption = (target) => {
        var oldArr = question.options.filter(o => o !== target);
        var newArr = [];
        oldArr.forEach(option => {
            newArr.push({
                ...option,
                order: newArr.length + 1
            })
        })
        setQuestion({
            ...question,
            options: newArr
        })
    }

    const handleQuestionType = (event) => {
        const old = question.type;
        switch(event.target.value) {
          case 'HORIZONTAL_SCALE':
            setQuestion({
                ...question,
                options: [{goto: goto, minimum: 'false', maximum: 'true'}],
                type: event.target.value
            });
            break;
          case 'Boolean':
            setQuestion({
              ...question,
              options: [{goto: goto, label: 'Yes', value: '1', order: 1}, {goto: goto, label: 'No', value: '0', order: 2}],
              type: event.target.value
            });
            break;
          case 'LIST_MULTI':
          case 'LIST_SINGLE':
          case 'MATRIX_MULTI':
            if (old === 'LIST_MULTI' || old === 'LIST_SINGLE' || old === 'MATRIX_MULTI') {
                setQuestion({
                    ...question,
                    type: event.target.value
                })
            } else {
                setQuestion({
                    ...question,
                    options: [],
                    type: event.target.value
                });
            }
            break;
          default: 
            setQuestion({
              ...question,
              options: [{goto: goto}],
              type: event.target.value
            });
        }
    }

    const handleScaleLabel = (name) => ({ target: { value } }) => {
        setQuestion({
            ...question,
            options: [{...question.options[0], [name]: value}]
        })
    };
    const handleChange = (name) => ({ target: { value } }) => {
        setQuestion({ ...question, [name]: value });
    };
    const onTagsChanged = (tags) => {
		setQuestion({
			...question,
			tag: tags
		});
    };

    const handleGoto = (event) => {
        setGoto(event.target.value);
        const tmp = question;
        tmp.options.forEach((option, index) => {
            tmp.options[index].goto = event.target.value;
        });
        setQuestion(tmp);
    }

    const handleUpdate = () => {
        var formatted = question;
        formatted.options.forEach((option, index) => {
            if (typeof option !== 'string') {
                formatted.options[index] = JSON.stringify(option);
            }
        });
        // console.log("FORMATTED ::", formatted);
        onUpdate(formatted);
    }

    const validate = () => {
        if (
          question.label
          && question.localization 
          && question.options.length > 0
        ) {
          return false;
        } else {
          return true;
        }
    }

    return (
        <>
            {question && (
            <>
                <Row style={{flex: 1}}>
                    <Col style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}> 
                        <div className="survey-screen-section">
                            {mode === 'general' && (<>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Localization"
                                    helperText="Localization/Language of your question (e.g. US-EN)"
                                    type="text"
                                    fullWidth
                                    value={question.localization}
                                    onChange={handleChange('localization')}
                                />
                                <TextField
                                    margin="dense"
                                    label="Instructions"
                                    type="text"
                                    placeholder="Add instructions for the question here"
                                    helperText="Add instructions for the question here"
                                    multiline
                                    fullWidth
                                    value={question.instructions}
                                    onChange={handleChange('instructions')}
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Label"
                                    helperText="Add a label to distinguish your question here"
                                    type="text"
                                    fullWidth
                                    value={question.label}
                                    onChange={handleChange('label')}
                                />
                                {question.hasOwnProperty('dictionnary') && (
                                    <TextField
                                        margin="dense"
                                        label="Dictionnary Label"
                                        type="text"
                                        placeholder="Add instructions for the question here"
                                        helperText="Add label for dictionnary for the question here"
                                        multiline
                                        fullWidth
                                        value={question.dictionnary}
                                        onChange={handleChange('dictionnary')}
                                    />
                                )}
                                {question.hasOwnProperty('description') && (
                                    <TextField
                                        margin="dense"
                                        label="Description"
                                        placeholder="Enter a description for the question here"
                                        helperText="Enter a description for the question here"
                                        type="text"
                                        multiline
                                        fullWidth
                                        value={question.description}
                                        onChange={handleChange('description')}
                                    />
                                )}
                                <TextField
                                    margin="dense"
                                    label="Help"
                                    placeholder="Add help guide for the question here"
                                    helperText="Add help guide for the question here"
                                    type="text"
                                    multiline
                                    fullWidth
                                    value={question.help}
                                    onChange={handleChange('help')}
                                />
                                <FormLabel className="mt-4">Tags</FormLabel>
                                <TagsInput tags={question.tag} onTagsChanged={onTagsChanged} />
                            </>)}
                            {mode === 'choices' && (<>
                                <InputLabel className="mt-4" id="suvey-type-label">Type</InputLabel>
                                <Select
                                    value={question.type}
                                    onChange={handleQuestionType}
                                    displayEmpty
                                    fullWidth
                                >
                                    <MenuItem value="">
                                    <em>None</em>
                                    </MenuItem>
                                    {questionTypes.map((item, index) => 	<MenuItem key={"survey-type-" + index} value={item.type}>{item.label}</MenuItem>
                                    )}
                                </Select>
                                <FormHelperText>Add a type for the question here</FormHelperText>
                                {question.type === 'LIST_SINGLE' || question.type === 'LIST_MULTI' || question.type === 'MATRIX_MULTI' || question.type === 'MATRIX_SINGLE' || question.type === 'Boolean' ? (
                                <>
                                    {question.type !== 'Boolean' && (
                                    <>
                                        <InputLabel className="mt-4" id="suvey-type-label">New Choice</InputLabel>
                                        <div className="d-flex">
                                            <TextField
                                                name="label"
                                                margin="dense"
                                                type="text"
                                                placeholder="Label"
                                                helperText="Add choice label here"
                                                multiline
                                                fullWidth
                                                value={newOption.label}
                                                onChange={handleNewOption}
                                            />
                                            <FormButton onClick={addOption} color="primary" >ADD</FormButton>
                                        </div>
                                    </>
                                    )}
                                    {question.options.length > 0 ? (
                                        <>
                                        <FormLabel className="mt-2">Choices</FormLabel>
                                        <Row>
                                            <Col xs={1} className="builder-option-label"></Col>
                                            <Col xs={4} className="builder-option-label">LABEL</Col>
                                            <Col xs={3} className="builder-option-label">VALUE</Col>
                                            <Col xs={3} className="builder-option-label">GO TO</Col>
                                            <Col xs={1} className="builder-option-label"></Col>
                                        </Row>
                                        {question.options.map((option, index) => {
                                            return (
                                                <Row key={"NEW-OPTION-" + index} className="align-items-center mb-1">
                                                    <Col xs={1} className="text-center">
                                                        <FormButton onClick={() => deleteOption(option)} color="primary" className="small-builder-btn" disabled={question.type === 'Boolean' ? true : false}><TiTimes /></FormButton>
                                                    </Col>
                                                    <Col xs={4} >
                                                        <input 
                                                            className="choices-edit-input" 
                                                            value={option.label} 
                                                            onChange={event => editOption(event.target.value, index, 'label')} 
                                                            disabled={question.type === 'Boolean' ? true : false}
                                                        />
                                                    </Col>
                                                    <Col xs={3} >
                                                        <input 
                                                            className="choices-edit-input" 
                                                            value={option.value} 
                                                            onChange={event => editOption(event.target.value, index, 'value')} 
                                                            disabled={question.type === 'Boolean' ? true : false}
                                                        />
                                                    </Col>
                                                    <Col xs={3} className="builder-option-col" >
                                                        <Select
                                                            multiline
                                                            displayEmpty
                                                            fullWidth
                                                            className="choices-edit-input choices-edit-input-select"
                                                            value={option.goto} 
                                                            onChange={event => editOption(event.target.value, index, 'goto')} 
                                                        >
                                                            <MenuItem value="">
                                                                <em>Go To: None</em>
                                                            </MenuItem>
                                                            {gotoOptions.map((item, index) => 	
                                                                <MenuItem key={"goto-type-" + index} value={item.value}>{item.label}</MenuItem>
                                                            )}
                                                        </Select>
                                                    </Col>
                                                    <Col xs={1} className="builder-option-col">
                                                        <FormButton onClick={() => reorder(option)} color="primary" className="small-builder-btn small-builder-btn-absolute" disabled={question.type === 'Boolean' ? true : false}><BiArrowFromBottom /></FormButton>
                                                    </Col>
                                                </Row>
                                            )
                                        })}
                                        </>
                                    ) : null}
                                </>
                                ) : <>
                                    <InputLabel className="mt-4">Go To</InputLabel>
                                    <Select
                                        name="goto"
                                        value={goto}
                                        onChange={handleGoto}
                                        multiline
                                        displayEmpty
                                        fullWidth
                                        className="mb-3"
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        {gotoOptions.map((item, index) => 	
                                            <MenuItem key={"default-goto-type-" + index} value={item.value}>{item.label}</MenuItem>
                                        )}
                                    </Select>
                                </>}
                                {question.type === 'HORIZONTAL_SCALE' && (
                                    <>
                                        <InputLabel className="mt-4">Minimum Label: </InputLabel>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            name="minimum"
                                            helperText="Define the minimum value"
                                            type="text"
                                            fullWidth
                                            value={question.options[0].minimum}
                                            onChange={handleScaleLabel('minimum')}
                                        />
                                        <InputLabel className="mt-4">Maximum Label: </InputLabel>
                                        <TextField
                                            autoFocus
                                            margin="dense"
                                            name="maximum"
                                            helperText="Define the maximum value"
                                            type="text"
                                            fullWidth
                                            value={question.options[0].maximum}
                                            onChange={handleScaleLabel('maximum')}
                                        />
                                    </>
                                )}
                            </>)}
                        </div>  

                        {showActionButtons && (
                            <div className="d-flex align-items-end justify-content-center my-3" style={{flex: 1}}>
                                <div>
                                    <div>
                                        <button className="nav-btn" style={{width: 180}} disabled={validate()} onClick={handleUpdate}>Update <MdSystemUpdateAlt/></button>
                                    </div>
                                    <div>
                                        <button className="nav-btn" style={{width: 180}} onClick={() => onDelete(originalQuestion)}>Delete <BsTrash2/></button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
            </>
            )}
        </>
    )
}

export default Builder;